@if (hasValidId()) {
  <a [routerLink]="this.url() + this.id()">{{ this.label() }}</a>
  <span class="ps-1">
  <a [routerLink]="this.url() + this.id()" target="_blank">
    <span #mdi id="mdi" class="mdi mdi-open-in-new " [class.max-size]="this.overMaxSize"></span>
  </a>
</span>
} @else {
  {{ this.label() }}
  <span #mdi id="mdi" class="mdi mdi-open-in-new invisible" [class.max-size]="this.overMaxSize"></span>
}

